import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(_vm.$t("menu.customer.companies_reports_title")) +
            " - " +
            _vm._s(_vm.company_name)
        ),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(VDataTable, {
            key: _vm.keyDashboardsList,
            staticClass: "text-center table-inca",
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.items,
              headers: _vm.headers,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.report.maintenance
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            { attrs: { icon: "" } },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-information-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("En mantenimiento")])]
                        )
                      : _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onVer(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("mdi-eye")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Ver")])]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      !_vm.send_token
        ? _c("AgreementsComponent", {
            ref: "agreement",
            on: { onAccept: _vm.onAccept, onClose: _vm.onClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.agreement_text) },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1584626502
            ),
          })
        : _vm._e(),
      _c("TokenComponent", {
        ref: "tokencomponent",
        on: { sendToken: _vm.sendToken },
      }),
      _c(
        "div",
        { staticClass: "vertical-center" },
        [
          _vm.decline
            ? _c(
                VCard,
                { staticClass: " rounded-xl ", attrs: { "min-width": "350" } },
                [
                  _c(VCardText, { staticClass: "p-0" }, [
                    _c("div", { class: "header-alert " + _vm.color }, [
                      _c(
                        "span",
                        { staticClass: "vertical-center circle1" },
                        [
                          _c(
                            VIcon,
                            {
                              staticClass: "vertical-center",
                              attrs: { color: "white" },
                            },
                            [_vm._v("mdi-alert")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "header-body p-4 text-center",
                        staticStyle: {
                          "max-height": "500px",
                          "overflow-y": "scroll",
                        },
                      },
                      [
                        _c("h5", { class: _vm.color + "--text" }, [
                          _vm._v("¡Información incompleta!"),
                        ]),
                        _c("br"),
                        _c("p", { staticClass: "pb-0" }, [
                          _vm._v("Es necesario "),
                          _c("strong", [_vm._v("leer y aceptar el acuerdo")]),
                          _vm._v(" de "),
                          _c("br"),
                          _vm._v("confidencialidad para poder continuar."),
                        ]),
                        _c(
                          "div",
                          { staticStyle: { display: "inline-grid" } },
                          [
                            _c(
                              VBtn,
                              {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  rounded: "",
                                  small: "",
                                },
                                on: { click: _vm.onVolver },
                              },
                              [
                                _c(VIcon, [_vm._v("mdi-chevron-left")]),
                                _vm._v(" Ver contrato de confidencialidad "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }